const LOGIN_RETURN_TARGET_KEY = 'qcyy_admin_login_return_target'
const LOGIN_RETURN_TARGET_TTL_MS = 30 * 60 * 1000
const LOGIN_PATH = '/login'
const DEFAULT_REDIRECT_PATH = '/admin/dashboard'
let consumedReturnTargetPath = ''

function canUseLocalStorage() {
    try {
        return typeof window !== 'undefined' && !!window.localStorage
    } catch (error) {
        return false
    }
}

function isSafeRedirectPath(path) {
    const value = String(path || '').trim()
    if (!value || !value.startsWith('/') || value.startsWith('//')) {
        return false
    }
    const basePath = value.split(/[?#]/)[0]
    return basePath !== LOGIN_PATH && (basePath === '/admin' || basePath.startsWith('/admin/'))
}

function firstRedirectValue(path) {
    return Array.isArray(path) ? path[0] : path
}

function decodeRedirectValue(path) {
    const value = String(firstRedirectValue(path) || '').trim()
    if (!value) {
        return ''
    }
    try {
        return decodeURIComponent(value)
    } catch (error) {
        return value
    }
}

function stripHashModePath(path) {
    if (path.startsWith('/#/')) {
        return path.slice(2)
    }
    if (path.startsWith('#/')) {
        return path.slice(1)
    }
    return path
}

function normalizeRedirectPath(path) {
    let value = stripHashModePath(decodeRedirectValue(path))
    if (/^[a-z][a-z0-9+.-]*:\/\//i.test(value)) {
        try {
            const parsed = new URL(value)
            if (typeof window !== 'undefined' && parsed.origin !== window.location.origin) {
                return ''
            }
            value = parsed.hash && parsed.hash.startsWith('#/')
                ? parsed.hash.slice(1)
                : `${parsed.pathname}${parsed.search}${parsed.hash}`
        } catch (error) {
            return ''
        }
    }
    // 兼容从浏览器完整地址、hash 地址或双重编码 redirect 传入的后台内部路由。
    value = stripHashModePath(value)
    return isSafeRedirectPath(value) ? value : ''
}

function readStoredReturnTarget() {
    if (!canUseLocalStorage()) {
        return ''
    }
    try {
        const raw = window.localStorage.getItem(LOGIN_RETURN_TARGET_KEY)
        const target = raw ? JSON.parse(raw) : null
        const path = normalizeRedirectPath(target && target.path)
        const createdAt = Number(target && target.createdAt)
        if (!path || !createdAt || Date.now() - createdAt > LOGIN_RETURN_TARGET_TTL_MS) {
            clearLoginReturnTarget()
            return ''
        }
        return path
    } catch (error) {
        clearLoginReturnTarget()
        return ''
    }
}

export function saveLoginReturnTarget(path) {
    const targetPath = normalizeRedirectPath(path)
    if (!targetPath || !canUseLocalStorage()) {
        clearLoginReturnTarget()
        return ''
    }
    if (consumedReturnTargetPath) {
        const shouldSkipCurrentPath = consumedReturnTargetPath === targetPath
        consumedReturnTargetPath = ''
        if (shouldSkipCurrentPath) {
            return targetPath
        }
    }
    // 只保存后台内部路由，防止登录成功后跳回登录页或外部地址。
    try {
        window.localStorage.setItem(LOGIN_RETURN_TARGET_KEY, JSON.stringify({
            path: targetPath,
            createdAt: Date.now(),
        }))
    } catch (error) {
        return targetPath
    }
    return targetPath
}

export function clearLoginReturnTarget() {
    try {
        if (!canUseLocalStorage()) {
            return
        }
        window.localStorage.removeItem(LOGIN_RETURN_TARGET_KEY)
    } catch (error) {
    }
}

export function buildLoginRoute(currentFullPath) {
    const redirect = saveLoginReturnTarget(currentFullPath)
    return redirect ? {path: LOGIN_PATH, query: {redirect}} : {path: LOGIN_PATH}
}

export function resolvePostLoginRedirect(queryRedirect, options = {}) {
    const shouldReadStoredTarget = options.readStoredTarget !== false
    const redirect = normalizeRedirectPath(queryRedirect) || (shouldReadStoredTarget ? readStoredReturnTarget() : '')
    clearLoginReturnTarget()
    const targetPath = redirect || DEFAULT_REDIRECT_PATH
    // 登录成功后下一次进入目标页不再反写缓存，避免已消费的回跳目标污染手动登录。
    consumedReturnTargetPath = targetPath
    return targetPath
}
